module.exports = __webpack_public_path__ + "static/media/logo_text.d7815b8e.svg";